import { useState } from 'react';

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "Est-ce que ça me coûte quelque chose ?",
      answer: "Non, c'est 100% gratuit ! Aucun frais de démarrage, aucun coût caché, aucun abonnement. Nous ne gagnons de l'argent que si vous en gagnez plus."
    },
    {
      question: "Dois-je changer mon menu ?",
      answer: "Absolument pas ! Nous créons des marques virtuelles autour de votre carte existante. Vous continuez à préparer les mêmes plats avec les mêmes ingrédients."
    },
    {
      question: "Et si ça ne marche pas ?",
      answer: "Aucun risque, aucun engagement ! Si vous n'êtes pas satisfait des résultats, vous pouvez arrêter à tout moment sans aucune pénalité."
    },
    {
      question: "Combien de temps avant de voir les résultats ?",
      answer: "Les premières commandes arrivent généralement dans les 7 à 14 jours après le lancement de vos marques virtuelles sur les plateformes."
    },
    {
      question: "Dois-je gérer quelque chose ?",
      answer: "Non ! Nous nous occupons de tout : création des marques, visuels, marketing, optimisation. Vous n'avez qu'à préparer les commandes supplémentaires."
    },
    {
      question: "Comment ça marche concrètement ?",
      answer: "Nous créons plusieurs concepts de restaurants virtuels basés sur votre cuisine, les optimisons pour les plateformes de livraison, et gérons tout le marketing pour attirer plus de clients."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 sm:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-gray-900 mb-4 sm:mb-6">
            Questions
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              {" "}fréquentes
            </span>
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-5 sm:px-8 py-4 sm:py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
              >
                <h3 className="text-base sm:text-lg md:text-xl font-heading font-semibold text-gray-900 pr-3 sm:pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl sm:text-2xl text-purple-600 transition-transform duration-200`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-5 sm:px-8 pb-4 sm:pb-6">
                  <div className="border-t border-gray-100 pt-4 sm:pt-6">
                    <p className="text-gray-600 leading-relaxed text-sm sm:text-base md:text-lg font-primary">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 text-center">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-6 sm:p-8 text-white">
            <h3 className="text-xl sm:text-2xl font-heading font-bold mb-3 sm:mb-4">
              Vous avez d'autres questions ?
            </h3>
            <p className="text-purple-100 mb-5 sm:mb-6 font-accent text-sm sm:text-base">
              Notre équipe BrandBoost est là pour vous répondre et vous accompagner
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
              <a
                href="tel:0602517324"
                className="inline-flex items-center bg-white text-purple-600 font-accent font-semibold px-5 sm:px-6 py-3 rounded-full hover:bg-gray-100 transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm sm:text-base w-full sm:w-auto justify-center"
              >
                <i className="ri-phone-line mr-2"></i>
                06 02 51 73 24
              </a>
              <a
                href="mailto:contact@boostyourbrand.io"
                className="inline-flex items-center bg-white/10 text-white font-accent font-semibold px-5 sm:px-6 py-3 rounded-full hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm sm:text-base w-full sm:w-auto justify-center"
              >
                <i className="ri-mail-line mr-2"></i>
                contact@boostyourbrand.io
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
